
export enum GrowthThresholds {
  HIGH = 66,
  MODERATE = 35,
  LOW = 1
}
